import vPagination from "./v-pagination.vue";

export default Vue => {
  Vue.component("v-pagination", vPagination);
};
